// Global flag – used to know if the drawer should open on next update
window.__openCartAfterAdd = window.__openCartAfterAdd || false;

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          this.initCartSlider();

        // This just says "mini-cart HTML loaded"
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.initCartSlider();

    // ✅ Only open drawer if an Add to Cart click explicitly requested it
    if (window.__openCartAfterAdd) {
      this.open();
      window.__openCartAfterAdd = false; // reset flag
    }
  }

  initCartSlider() {
    // Thoda sa delay (100ms) taaki DOM update confirm ho jaye
    setTimeout(() => {
      const $slider = $('.slick-recommendations'); // Aapki class jo Liquid mein thi
      
      if ($slider.length > 0) {
        // Agar slider pehle se chal raha hai toh usse hata kar dobara lagayein (Destruction)
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        $slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="slick-prev">←</button>',
          nextArrow: '<button type="button" class="slick-next">→</button>',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                arrows: true
              }
            }
          ]
        });
      }
    }, 100);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

// // Free gift card msg and progress bar

// (function () {
//   var lastDiscountedSubtotal = null;
//   var updateTimer = null;

//   function moneyTextToCents(text) {
//     if (!text) return null;

//     var matches = text.match(/\$?\s*\d[\d,]*(?:\.\d{2})?/g);
//     if (!matches || !matches.length) return null;

//     // Stack app text usually comes like "$260.00$180.00"
//     // So we use the last price = discounted subtotal
//     var lastPrice = matches[matches.length - 1];
//     var cleanValue = lastPrice.replace(/[^0-9.]/g, '');
//     var amount = parseFloat(cleanValue);

//     if (isNaN(amount)) return null;

//     return Math.round(amount * 100);
//   }

//   function formatMoney(cents) {
//     return '$' + (cents / 100).toFixed(2);
//   }

//   function getDiscountedSubtotalCents() {
//     var subtotalEl = document.querySelector('#stack-discounts-subtotal-value');

//     if (subtotalEl) {
//       var subtotalText = subtotalEl.innerText || subtotalEl.textContent;
//       var subtotalFromText = moneyTextToCents(subtotalText);

//       if (subtotalFromText !== null) {
//         lastDiscountedSubtotal = subtotalFromText;
//         return subtotalFromText;
//       }
//     }

//     return lastDiscountedSubtotal;
//   }

//   function updateGiftCardMessage() {
//     var wrappers = document.querySelectorAll('.js-free-gift-msg');
//     var discountedSubtotal = getDiscountedSubtotalCents();

//     if (!wrappers.length || discountedSubtotal === null) return;

//     wrappers.forEach(function (wrapper) {
//       var messageEl = wrapper.querySelector('.js-free-gift-message-text');
//       if (!messageEl) return;

//       var giftMinimum = parseInt(wrapper.getAttribute('data-gift-minimum'), 10);
//       var successMessage = wrapper.getAttribute('data-success-message') || '';

//       if (!giftMinimum) return;

//       var newMessage = '';

//       if (discountedSubtotal >= giftMinimum) {
//           messageEl.classList.add('free-shipping__text--success');

//           newMessage =
//             '<span class="icon-success">' +
//               '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//                 '<circle cx="10" cy="10" r="10" fill="#28A745"></circle>' +
//                 '<path d="M5 10.5L8.2 13.7L15 6.8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
//               '</svg>' +
//             '</span>' +
//             successMessage;
//         } else {
//           var remainingAmount = giftMinimum - discountedSubtotal;

//           messageEl.classList.remove('free-shipping__text--success');

//           newMessage =
//             'Spend <price-money class="price"><bdi>' +
//             formatMoney(remainingAmount) +
//             '</bdi></price-money> more and receive a FREE $20 Gift Card.';
//         }

//       if (messageEl.innerHTML.trim() !== newMessage.trim()) {
//         messageEl.innerHTML = newMessage;
//       }
//     });
//   }

//   function updateGiftCardProgress() {
//     var progressBars = document.querySelectorAll('.js-free-gift-progress');
//     var discountedSubtotal = getDiscountedSubtotalCents();

//     if (!progressBars.length || discountedSubtotal === null) return;

//     progressBars.forEach(function (progressBar) {
//       var giftMinimum = parseInt(progressBar.getAttribute('data-gift-minimum'), 10);

//       if (!giftMinimum) return;

//       var progressPercent = Math.min((discountedSubtotal / giftMinimum) * 100, 100);
//       var roundedProgress = Math.round(progressPercent);

//       progressBar.style.setProperty('--progress', roundedProgress + '%');

//       if (discountedSubtotal >= giftMinimum) {
//         progressBar.classList.add('free-shipping__progress--success');
//       } else {
//         progressBar.classList.remove('free-shipping__progress--success');
//       }
//     });
//   }

//   function scheduleGiftCardUpdate() {
//     clearTimeout(updateTimer);

//     updateTimer = setTimeout(function () {
//       updateGiftCardMessage();
//       updateGiftCardProgress();
//     }, 300);
//   }

//   function runGiftCardUpdate() {
//     scheduleGiftCardUpdate();

//     setTimeout(scheduleGiftCardUpdate, 800);
//     setTimeout(scheduleGiftCardUpdate, 1500);
//     setTimeout(scheduleGiftCardUpdate, 2500);
//     setTimeout(scheduleGiftCardUpdate, 4000);
//   }

//   document.addEventListener('DOMContentLoaded', runGiftCardUpdate);
//   document.addEventListener('cart:updated', runGiftCardUpdate);
//   document.addEventListener('cart:refresh', runGiftCardUpdate);
//   document.addEventListener('theme:cart:change', runGiftCardUpdate);
//   document.addEventListener('drawer:open', runGiftCardUpdate);
//   document.addEventListener('cart-drawer:open', runGiftCardUpdate);

//   document.addEventListener('click', function () {
//     setTimeout(runGiftCardUpdate, 500);
//   });

//   var pageObserver = new MutationObserver(function () {
//     scheduleGiftCardUpdate();
//   });

//   // Gift-card progress markup only ever renders inside the header (mini-cart)
//   // and main content (cart page footer), both within .transition-body.
//   // Falls back to document.body if that wrapper is ever missing, so
//   // coverage can never be narrower than before.
//   var observedRoot = document.querySelector('.transition-body') || document.body;

//   pageObserver.observe(observedRoot, {
//     childList: true,
//     subtree: true
//   });

//   runGiftCardUpdate();
// })();


// Free gift card msg and progress bar

(function () {
  var lastDiscountedSubtotal = null;
  var excludedGiftCardTotal = 0;
  var updateTimer = null;

  var excludedGiftCardHandle = 'riley-gift-card';

  function moneyTextToCents(text) {
    if (!text) return null;

    var matches = text.match(/\$?\s*\d[\d,]*(?:\.\d{2})?/g);
    if (!matches || !matches.length) return null;

    // Stack app text may look like "$260.00$180.00".
    // Use the last price as the discounted subtotal.
    var lastPrice = matches[matches.length - 1];
    var cleanValue = lastPrice.replace(/[^0-9.]/g, '');
    var amount = parseFloat(cleanValue);

    if (isNaN(amount)) return null;

    return Math.round(amount * 100);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getExcludedGiftCardTotal() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load cart');
        }

        return response.json();
      })
      .then(function (cart) {
        excludedGiftCardTotal = cart.items.reduce(function (total, item) {
          if (item.handle === excludedGiftCardHandle) {
            return total + item.final_line_price;
          }

          return total;
        }, 0);

        return excludedGiftCardTotal;
      })
      .catch(function () {
        return excludedGiftCardTotal;
      });
  }

  function getDiscountedSubtotalCents() {
    var subtotalEl = document.querySelector(
      '#stack-discounts-subtotal-value'
    );

    if (subtotalEl) {
      var subtotalText = subtotalEl.innerText || subtotalEl.textContent;
      var subtotalFromText = moneyTextToCents(subtotalText);

      if (subtotalFromText !== null) {
        lastDiscountedSubtotal = subtotalFromText;
      }
    }

    if (lastDiscountedSubtotal === null) {
      return null;
    }

    // Exclude the Riley Gift Card from the qualifying subtotal.
    return Math.max(
      lastDiscountedSubtotal - excludedGiftCardTotal,
      0
    );
  }

  function updateGiftCardMessage() {
    var wrappers = document.querySelectorAll('.js-free-gift-msg');
    var discountedSubtotal = getDiscountedSubtotalCents();

    if (!wrappers.length || discountedSubtotal === null) return;

    wrappers.forEach(function (wrapper) {
      var messageEl = wrapper.querySelector(
        '.js-free-gift-message-text'
      );

      if (!messageEl) return;

      var giftMinimum = parseInt(
        wrapper.getAttribute('data-gift-minimum'),
        10
      );

      var successMessage =
        wrapper.getAttribute('data-success-message') || '';

      if (!giftMinimum) return;

      var newMessage = '';

      if (discountedSubtotal >= giftMinimum) {
        messageEl.classList.add(
          'free-shipping__text--success'
        );

        newMessage =
          '<span class="icon-success">' +
            '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="10" cy="10" r="10" fill="#28A745"></circle>' +
              '<path d="M5 10.5L8.2 13.7L15 6.8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '</svg>' +
          '</span>' +
          successMessage;
      } else {
        var remainingAmount =
          giftMinimum - discountedSubtotal;

        messageEl.classList.remove(
          'free-shipping__text--success'
        );

        newMessage =
          'Spend <price-money class="price"><bdi>' +
          formatMoney(remainingAmount) +
          '</bdi></price-money> more and receive a FREE $20 Gift Card.';
      }

      if (
        messageEl.innerHTML.trim() !==
        newMessage.trim()
      ) {
        messageEl.innerHTML = newMessage;
      }
    });
  }

  function updateGiftCardProgress() {
    var progressBars = document.querySelectorAll(
      '.js-free-gift-progress'
    );

    var discountedSubtotal =
      getDiscountedSubtotalCents();

    if (
      !progressBars.length ||
      discountedSubtotal === null
    ) {
      return;
    }

    progressBars.forEach(function (progressBar) {
      var giftMinimum = parseInt(
        progressBar.getAttribute('data-gift-minimum'),
        10
      );

      if (!giftMinimum) return;

      var progressPercent = Math.min(
        (discountedSubtotal / giftMinimum) * 100,
        100
      );

      var roundedProgress =
        Math.round(progressPercent);

      progressBar.style.setProperty(
        '--progress',
        roundedProgress + '%'
      );

      if (discountedSubtotal >= giftMinimum) {
        progressBar.classList.add(
          'free-shipping__progress--success'
        );
      } else {
        progressBar.classList.remove(
          'free-shipping__progress--success'
        );
      }
    });
  }

  function scheduleGiftCardUpdate() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      getExcludedGiftCardTotal().then(function () {
        updateGiftCardMessage();
        updateGiftCardProgress();
      });
    }, 300);
  }

  function runGiftCardUpdate() {
    scheduleGiftCardUpdate();

    setTimeout(scheduleGiftCardUpdate, 800);
    setTimeout(scheduleGiftCardUpdate, 1500);
    setTimeout(scheduleGiftCardUpdate, 2500);
    setTimeout(scheduleGiftCardUpdate, 4000);
  }

  document.addEventListener(
    'DOMContentLoaded',
    runGiftCardUpdate
  );

  document.addEventListener(
    'cart:updated',
    runGiftCardUpdate
  );

  document.addEventListener(
    'cart:refresh',
    runGiftCardUpdate
  );

  document.addEventListener(
    'theme:cart:change',
    runGiftCardUpdate
  );

  document.addEventListener(
    'drawer:open',
    runGiftCardUpdate
  );

  document.addEventListener(
    'cart-drawer:open',
    runGiftCardUpdate
  );

  document.addEventListener('click', function () {
    setTimeout(runGiftCardUpdate, 500);
  });

  var pageObserver = new MutationObserver(function () {
    scheduleGiftCardUpdate();
  });

  var observedRoot =
    document.querySelector('.transition-body') ||
    document.body;

  pageObserver.observe(observedRoot, {
    childList: true,
    subtree: true
  });

  runGiftCardUpdate();
})();
